// extracted by mini-css-extract-plugin
export var container = "_bz-1";
export var cornerButtonContainer = "_bz-6";
export var disabled = "_bz-2";
export var dragActive = "_bz-3";
export var fileContainer = "_bz-5";
export var hiddenInput = "_bz-4";
export var widthContainer = "_bz-0";